import styled from "styled-components";

import Colors from "@constants/Colors";
import { Box, Button, Dialog } from "@mui/material";
import { ZIndex } from "@src/constants";

export const StyledBox = styled(Box)`
  background-color: ${Colors.white} !important;
  padding: 34px 16px;
  display: flex;
  flex-direction: column;
  gap: 44px;
  align-items: center;
`;

export const LocationSelectorWrapper = styled(Dialog)`
  width: 500px;
`;

export const StyledButton = styled(Button)<{ disabled: boolean }>`
  background: ${({ disabled }: { disabled: boolean }) =>
    disabled ? Colors.neutral_gray_200 : Colors.secondary} !important;
  border-radius: 8px !important;
  width: 100%;
  color: ${({ disabled }: { disabled: boolean }) =>
    disabled ? Colors.primarygray_300 : Colors.white} !important;
  font-family: "Ringside Regular-bold" !important;
  text-transform: capitalize !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  height: 40px !important;
`;
